import { connect } from 'react-redux';
import Veiculos from './veiculos';

export default connect()(Veiculos);
